// Import type is not bundled to prod code
import type * as filestack from 'filestack-js';
import { getWindowInBrowser } from '../../../RuntimeWindow';

const EMPTY_RESPONSE: filestack.PickerResponse = {
    filesUploaded: [],
    filesFailed: [],
};

export type PickerClient = Pick<filestack.Client, 'picker'>;

let pendingClient: Promise<PickerClient> | null = null;

function createClient(): Promise<PickerClient> {
    const getFilestackClient =
        getWindowInBrowser().runtime?.API?.getFilestackClient;

    if (!getFilestackClient) {
        return Promise.reject(
            new Error('runtime.API.getFilestackClient is unavailable')
        );
    }

    return Promise.resolve().then(() => getFilestackClient());
}

export function init(): Promise<PickerClient> {
    pendingClient =
        pendingClient ??
        createClient().catch((error) => {
            pendingClient = null;

            throw error;
        });

    return pendingClient;
}

export function resetClient() {
    pendingClient = null;
}

export async function picker(
    apiKey: string,
    options: filestack.PickerOptions
): Promise<filestack.PickerResponse> {
    const filestackClient = await init();

    return new Promise((resolve, reject) => {
        filestackClient
            .picker({
                ...options,
                onUploadDone: resolve,
                onFileUploadFailed: reject,
                onClose: () => resolve(EMPTY_RESPONSE),
            })
            .open()
            .catch(reject);
    });
}

export type {
    Client,
    PickerFileMetadata,
    PickerInstance,
    PickerOptions,
    PickerResponse,
    StoreUploadOptions,
} from 'filestack-js';
